import { Component } from 'opus-angular-seed-core';
import template from './template.html';

/**
 * Review state of the translation of the selected chapter, optionally with the review actions.
 */
@Component({
    bindings: {
        heading: '<',
        text: '<',
        hasActions: '<',
        canRetranslate: '<',
        isDisabled: '<',
        isLoading: '<',
        onRetranslate: '&',
        onConfirm: '&'
    },
    template
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/reviewBanner/index.js